export default __webpack_public_path__ + "a332ce06a52f9f5d87de6d334917bf90.png";